import axios from "axios";
import { appConstants } from "./appConstants";

const output = (response) => {
  if (!response.data?.Result_Status)
    throw new Error(response.data?.Result_Message || "Organisation request failed.");
  return response.data.Result_Output;
};

export const fetchOrganisationContext = () =>
  axios.post(`${appConstants.baseURL}organisations/context`, {}).then(output);

export const createOrganisation = (values) =>
  axios.post(`${appConstants.baseURL}organisations`, values).then(output);

export const switchOrganisation = (businessUserID) =>
  axios
    .post(`${appConstants.baseURL}organisations/switch`, { businessUserID })
    .then(output);
